import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArticlesComponent } from './articles/articles.component';
import { SharedModule } from 'src/app/shared/shared.module';
// import { SharedModule } from 'src/app/shared/shared.module';
import { ArticlesRoutingModule } from './articles-routing.module';
import { ArticleDetailComponent } from './article-detail/article-detail.component';
import { KeyConsiderationComponent } from './key-consideration/key-consideration.component';
import { ResuscitationComponent } from './resuscitation/resuscitation.component';
import { CompleteGuideComponent } from './complete-guide/complete-guide.component';
import { CatholicFuneralComponent } from './catholic-funeral/catholic-funeral.component';
import { TerriSchiavoComponent } from './terri-schiavo/terri-schiavo.component';
import { IronDomeComponent } from './iron-dome/iron-dome.component';
import { HealthcareComponent } from './healthcare/healthcare.component';
import { FuneralComponent } from './funeral/funeral.component';
import { FuneralPlanningComponent } from './funeral-planning/funeral-planning.component';
import { FuneralReadingComponent } from './funeral-reading/funeral-reading.component';
import { LeavingLegacyComponent } from './leaving-legacy/leaving-legacy.component';
import { LeavingGodlylegacyComponent } from './leaving-godlylegacy/leaving-godlylegacy.component';
import { FuneralGuideComponent } from './funeral-guide/funeral-guide.component';
import { BlessingDepartedComponent } from './blessing-departed/blessing-departed.component';
import { BalancingBlessingComponent } from './balancing-blessing/balancing-blessing.component';
import { FinalWishesComponent } from './final-wishes/final-wishes.component';

@NgModule({
  declarations: [
    ArticlesComponent,
    ArticleDetailComponent,
    KeyConsiderationComponent,
    ResuscitationComponent,
    CompleteGuideComponent,
    CatholicFuneralComponent,
    TerriSchiavoComponent,
    IronDomeComponent,
    HealthcareComponent,
    FuneralComponent,
    FuneralPlanningComponent,
    FuneralReadingComponent,
    LeavingLegacyComponent,
    LeavingGodlylegacyComponent,
    FuneralGuideComponent,
    BlessingDepartedComponent,
    BalancingBlessingComponent,
    FinalWishesComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ArticlesRoutingModule
  ]
})
export class ArticlesModule { }
